import type { AudioDeviceContextValue } from 'providers/AudioDeviceProvider';
import { displayDeviceLabel } from 'utils/audio/displayDeviceLabel';

type NameSource = Pick<
  AudioDeviceContextValue,
  'recommendedCandidate' | 'selectedDevice' | 'settings'
>;

/** The remembered devices fill in for unplugged ones. */
export const deviceNames = (audio: NameSource) => ({
  jabra: displayDeviceLabel(
    audio.recommendedCandidate?.label ?? audio.settings.recommendedMicrophone?.label ?? ''
  ),
  device: displayDeviceLabel(
    audio.selectedDevice?.label ?? audio.settings.confirmedMicrophone?.label ?? ''
  ),
});
